<script lang="ts">
    import PageWrapper from "$lib/components/_page/PageWrapper.svelte";
    import AppError from '$lib/components/_page/app-error.svelte'
</script>

<PageWrapper footer={true}>
    <AppError showLogo={false}/>
</PageWrapper>
